module.exports = __webpack_public_path__ + "static/img/mbxt.a029740.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/mbxt.png
// module id = 3SIR
// module chunks = 0